import $ from 'jquery';
$(document).ready(function () {
    let movieContainer = document.querySelector(".video");
    
    if(movieContainer){
        let movie = movieContainer.querySelector(".video__content");
        let overlay = movieContainer.querySelector(".video__overlay");
        let videoPlaying = false;
    
        overlay.style.display = "block";
        
        function hideOverlay() {
            overlay.style.display = "none";
            videoPlaying = true;
            movie.play();
        }
    
        function showOverlay() {
            // this check is to differentiate seek and actual pause
            if (movie.readyState === 4) {
                overlay.style.display = "block";
                videoPlaying = true;
            }
        }
    
        movie.addEventListener('pause', showOverlay);
        overlay.addEventListener('click', hideOverlay);
    }
});
